import React, { Component } from 'react';

export class PlainValue extends Component {

    render() {
        return (
            <span className={this.props.className}>{this.props.value === undefined ? '-' : this.props.value}</span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/analytics/PlainValue.jsx